/**
 * Parcels Receipt
 */

// React
import React, {useEffect} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../../redux/reducers';
import {createPostOrderAction, getPostOrderWithIdAction} from '../../orders/actions';

// Selector
import {createStructuredSelector} from 'reselect';

//UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';

import {WrapperReceipt} from './style';
import jMoment from 'moment-jalaali';

// Helper
import {
  translateParcelType,
  translateServiceType,
} from '../../../utils/helpers';

// Type
import {SelectorProps, Props} from './interfaces';
import {
  makeSelectOrder,
  makeSelectLoading,
  makeSelectError,
  makeSelectPostOrder, makeSelectCurrentPostOrder,
} from '../../orders/selectors';
import {Payload} from '../../orders/interfaces';
import Barcode from 'react-barcode';
import { QRCode } from "react-qr-svg";
import { getOrderWithIdAction } from '../../deliveryOrders/actions';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();

  useEffect(() => {
    const {id} = props.match.params;
    props.getPostOrderDispatch({
      id,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.order.id) {
      window.print();
    }
  }, [props.order])

  return (
    <WrapperReceipt className={classes.root}>
      <div className="page">
        <div className=" wrapper ">
          {/*Section 1 */}
          <div
            className="flex"
          >
            <div style={{width: '100%'}} className="flex flex-column">
              <div className="flex flex-row" style={{margin: '5px 0'}}>
                <QRCode style={{width: 50}} value={props.order.barcode} />
                <div id="postWrapper" className="flex flex-column">
                  <img style={{width: '25px', margin: '5px 0'}} src="/post-logo2.png" alt="post-logo" />
                  <div id="postProps">
                    <span>{translateServiceType(props.order.serviceType)}</span>{' - '}
                    <span>{translateParcelType(props.order.parcelType)}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1"/>
          </div>

          {/* Section 1 */}
          <div className="card-a">
            <div className="card-a_box">

              <div className="card-a_item">
                <span className="card-a_label">{'مبدا: '}</span>
                <span className="card-a_text">
                  {'منطقه‌جنوب‌_‌روناد'}{' '}
                </span>
              </div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="card-a flex">
            <div className="card-a_box flex-1">
              <div className="card-a_item">
                <span className="card-a_label">{'مقصد: '}</span>
                <span className="card-a_text">
                  {props.order.postCity}
                </span>
              </div>
            </div>
            <div className="card-a_box flex-1">
              <div className="card-a_item">
                <span className="card-a_label">{'وزن: '}</span>
                <span className="card-a_text">
                  {props.order.weight}{' '}{'گرم'}
                </span>
              </div>
            </div>
          </div>

          {/* Section 2 */}
          <div className="card-a flex">
            <div className="card-a_box flex-1">
              <div className="card-a_item">
                <span className="card-a_label">{'تاریخ: '}</span>
                <span className="card-a_text">
                  {props.order.updated &&
                  jMoment(props.order.updated)
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}
                </span>
              </div>
            </div>
            <div className="card-a_box flex-1">
              <div className="card-a_item">
                <span className="card-a_label">{'زمان: '}</span>
                <span className="card-a_text">
                  {props.order.updated &&
                  jMoment(props.order.updated)
                    .locale('fa')
                    .format('HH:mm:ss')}
                </span>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="card-a">
            <div className="card-a_box">

              <div className="card-a_item">
                <span className="card-a_label">{'کرایه: '}</span>
                <span className="card-a_text">
                  {props.order.totalPrice}{' '}{'ریال'}
                </span>
              </div>
            </div>
          </div>

          {/* Section 5 */}
          <div id="barcode" style={{textAlign: 'center'}}>
            <Barcode
              style={{width: '100%'}}
              fontSize={12}
              value={props.order.barcode}
              height={'47px'}
              background="#ffffff"
            />
          </div>
        </div>
      </div>
    </WrapperReceipt>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  order: makeSelectCurrentPostOrder(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getPostOrderDispatch: (payload: {id: number}) =>
      dispatch(getPostOrderWithIdAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
